const $contains = {
  url: 'http://byepest.qing-rui.com',
  common: {
    object_name: '拜耳虫虫拜拜',
    phone: '400-188-8282',
    phone1: '4001888282',
    address: '上海市浦东新区花园石桥路33号花旗集团大厦18层',
    www: 'byepest@envu.com',
    connect_us: '联系我们',
    follow_us: '请使用微信扫一扫下单',
    search: '微信搜一搜',
    official_website: 'http://www.bayer.com.cn',
    beian: "http://beian.miit.gov.cn",
    allHotLine: '人工客服热线',
    headquartersAddress: '总部地址',
    searchAll: '查看全部',
    alt: '拜耳虫虫拜拜，从源头根除虫害问题',
    phone_text: '电话咨询',
    personal_user: '家庭服务',
    enterprise_user: '商业除虫',
    personal_service: '家庭服务',
    enterprise_service: '商业除虫'
  },
  home: {
    title: [
      {
        text: '首页',
        num: 176,
        path: '/'
      },
      {
        text: '关于我们',
        num: 146,
        path: '/about'
      },
      {
        text: '服务内容',
        num: 147,
        path: '/service'
      },
      {
        text: '选购与了解',
        num: 148,
        path: '/faq'
      },
      {
        text: '虫害百科',
        num: 220,
        path: '/pest_wiki'
      },
      {
        text: '非家庭服务',
        num: 0,
        path: '/enterprise/'
      }
    ],
    index: '首页',
    comeBackHome: '返回首页',
    about: '关于我们',
    service_mes: '服务内容',
    need_know: '选购与了解',
    pest_mes: '虫害百科',
    pest_mes_more: '虫害百科',
    service_terms: '服务协议',
    privacy_statement: '个人信息保护政策',
    bayer_official_website: '拜耳官网',
  },
  numCode: ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z']
}

export default $contains;



// WEBPACK FOOTER //
// ./src/controller/contains.js